import { DeleteIcon, EditIcon, InfiniteTable } from '@/components/_common';
import {
  useDeleteNfsInstallment,
  useNfsInstallments,
} from '@/core/domain/invoice/NfsInstallments/Installment.hook';
import {
  NfsInstallments,
  parseNfsInstallmentsPayamentType,
} from '@/core/domain/invoice/NfsInstallments/Installment.types';
import { getTableScrollX } from '@/utils/table';
import { Divider, Modal, Space } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import NfsInstallmentModalForm from '../NfsInstallmentModalForm';
import { useDisclosure } from '@/hooks';
import formatterPrice from '@/utils/number/formatterPrice';

interface Props {
  invoiceId: number;
  disabledFields: boolean;
}

const InvoiceInstallmentNFSETable: React.FC<Props> = ({
  invoiceId,
  disabledFields,
}) => {
  const { data, isLoading } = useNfsInstallments(invoiceId);

  const [installmentId, setInstallmentId] = useState<number>();
  const [modalCreateInstallmentOpened, modalCreateInstallmentAction] =
    useDisclosure();

  const removeMutation = useDeleteNfsInstallment();

  const handleEditInstallment = (installmentId: number) => {
    if (installmentId) {
      setInstallmentId(installmentId);

      modalCreateInstallmentAction.open();
    }
  };

  const handleRemoveClick = (installmentId: number) => {
    Modal.confirm({
      title: 'Remoção da parcela',
      content:
        'Deseja realmente remover a parcela, esse processo será irreverssível',
      onOk: async () => {
        await removeMutation.mutateAsync({ invoiceId, id: installmentId });
      },
      okType: 'danger',
    });
  };

  const columns: ColumnsType<NfsInstallments> = [
    {
      title: 'Número',
      dataIndex: 'number',
      key: 'number',
      width: 40,
      ellipsis: true,
    },
    {
      title: 'Vencimento',
      dataIndex: 'dueDate',
      key: 'description',
      width: 100,
      ellipsis: true,
    },
    {
      title: 'Tipo de pagamento',
      dataIndex: 'paymentType',
      key: 'paymentType',
      width: 100,
      ellipsis: true,
      render: (_, row) => parseNfsInstallmentsPayamentType[row.paymentType],
    },
    {
      title: 'Valor',
      dataIndex: 'value',
      key: 'value',
      width: 100,
      ellipsis: true,
      render: (value) => formatterPrice(value),
    },
    {
      dataIndex: 'actions',
      title: <FormattedMessage id="customers.list.header.actions" />,
      render: (_, record) => (
        <Space>
          <EditIcon
            iconProps={{ onClick: () => handleEditInstallment(record.id) }}
            disabled={disabledFields}
          />

          <Divider type="vertical" />

          <DeleteIcon
            onClick={() => handleRemoveClick(record.id)}
            disabled={disabledFields}
          />
        </Space>
      ),
      ellipsis: true,
      width: 100,
      align: 'right',
      fixed: 'right',
    },
  ];

  return (
    <>
      <InfiniteTable
        columns={columns}
        dataSource={data || []}
        scroll={{ x: getTableScrollX(columns) }}
        rowKey={(row) => row.id}
        pagination={false}
        loading={isLoading}
      />

      <NfsInstallmentModalForm
        open={modalCreateInstallmentOpened}
        onCancel={modalCreateInstallmentAction.close}
        onOk={() => null}
        invoiceId={Number(invoiceId)}
        installmentId={installmentId}
      />
    </>
  );
};

export default InvoiceInstallmentNFSETable;
